
import RequestAbstract from "../abstract";

export default class AccountingSystemAccounts extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting/system-accounts";
    }
}

